var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Header',{class:_vm.className,attrs:{"size":_vm.size},domProps:{"textContent":_vm._s(_vm.name)}})}
var staticRenderFns = []

export { render, staticRenderFns }